import ClipboardComponent from "@/app/components/ui/Clipboard";
import ModalInformation from "@/app/components/ui/Modals/Information";
import PersonaDiscountComments from "@/app/components/ui/PersonaDiscountComments";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";
import { useUtils } from "@/app/hooks/useUtils";
import { HandThumbUpIcon } from "@heroicons/react/24/outline";
import { IViewCommentsModalProps } from "../interface";

interface ViewCommentModalState {
  appointmentNotes: string;
  personaDiscountComments?: string[];
}

const ViewCommentModal: React.FC<IViewCommentsModalProps> = () => {
  const { convertNoteToArray } = useUtils();
  const { appointmentNotes, personaDiscountComments } = useModalState(
    "CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_VIEW_MORE",
  ) as ViewCommentModalState;
  // RBAC: PERSONA_DISCOUNT_COMMENTS_VIEW — controls visibility of the persona discount callout
  const canViewPersonaDiscountComments = useFeatureAccess("PERSONA_DISCOUNT_COMMENTS_VIEW");

  const flage = appointmentNotes?.startsWith("<ol>");
  const flage_li = appointmentNotes?.startsWith("<li><b>");

  const viewComment = () => {
    const cleanedArray = appointmentNotes
      .replace(/<li><b>/g, "")
      .replace(/<\/b><\/li>/g, "")
      .replace(/<\/ol>/g, "")
      .trim()
      .split(/\n|<br\s*\/?>|,/g) // optional splitting if multiple items
      .map((item) => item.trim()) // clean up extra spaces
      .filter((item) => item !== "");
    return cleanedArray;
  };

  const notes = flage_li ? viewComment() : flage ? convertNoteToArray(appointmentNotes) : appointmentNotes?.split("||");

  const commentData = notes?.filter((item) => item?.trim() !== "")?.filter((item) => item !== "Other:");

  return (
    <ModalInformation
      modalId="CUSTOMER_PROFILE_APPOINTMENTS_TABLE_COMMENTS_VIEW_MORE"
      title={`Comments`}
      dialogClassName="w-full sm:w-[85%] sm:max-w-md sm:my-6 sm:p-5 md:max-w-lg md:my-8 md:p-6 !translate-x-0"
    >
      {canViewPersonaDiscountComments && personaDiscountComments?.length > 0 && (
        <PersonaDiscountComments comments={personaDiscountComments} />
      )}
      <ol type="1" className="mt-4 w-full">
        {commentData?.map((com: string, idx) => {
          return (
            <li key={`${com}:${idx}`} className="flex w-full relative items-center justify-start  mt-2 ">
              <span className="w-5 h-5">
                <HandThumbUpIcon className="text-blue-500 text-xs" style={{ width: "13px", height: "13px" }} />
              </span>
              <p className="text-sm ml-2 text-black font-normal pr-5	">{com}</p>
              <ClipboardComponent
                className="ml-2 absolute right-0"
                copyId={`${com}:${idx}`}
                text={com}
                tooltipText="Copy Comment"
              />
            </li>
          );
        })}
      </ol>
    </ModalInformation>
  );
};
export default ViewCommentModal;
